// Theme Selection Screen
export const ThemeSelectionButtonTapped = (ctaTitle: string, portfolioTheme: string) => ({
  feature: 'Registration Portfolio Theme',
  event_description: 'Registration Portfolio Theme Selection',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'registrationSelectPortfolioThemeCTA',
  screen: 'registrationSelectPortfolioThemeScreen',
  screen_name: 'registrationSelectPortfolioThemeScreen',
  cta_title: ctaTitle,
  portfolio_theme: portfolioTheme,
})

// Preview Portfolio
export const PreviewPortfolioScreenViewed = (portfolioRisk: string) => ({
  object_name: 'registrationPreviewPortfolio',
  screen: 'registrationPreviewPortfolio',
  screen_name: 'registrationPreviewPortfolio',
  portfolio_risk: portfolioRisk,
})

export const PreviewPortfolioOpenAccountTapped = (portfolioRisk: string) => ({
  cta_title: 'Open Account',
  object_name: 'registrationPreviewPortfolioOpenAccount',
  screen: 'registrationPreviewPortfolio',
  screen_name: 'registrationPreviewPortfolio',
  portfolio_risk: portfolioRisk,
})

export const AboutYourPortfolioButtonTapped = (portfolioRisk: string) => ({
  object_name: 'registrationPreviewPortfolioViewedLearnMore',
  screen: 'registrationPreviewPortfolio',
  screen_name: 'registrationPreviewPortfolio',
  portfolio_risk: portfolioRisk,
})
